<template>
  <div class="advertisement-content">
    <!-- 项目列表 -->
    <div class="advertisement-content-list">
      <div 
        class="advertisement-content-list-item" 
        v-for="(item,index) in dataList" 
        :key="index"
        @click="handleDetail(item)"
      >
        <!-- 左侧：用户信息 -->
        <div class="item-left">
          <img :src="item.proPic || '../assets/default.png'" alt="" class="user-avatar">
          <span class="user-name">{{item.creatorName}}</span>
          <!-- <img src="../assets/company.png" alt="" class="user-type" v-if="item.userType == 2">
          <img src="../assets/person.png" alt="" class="user-type" v-else> -->
        </div>
        <!-- 中间：项目核心信息 -->
        <div class="item-middle">
          <h3 class="project-name">{{item.projectName}}</h3>
          <p class="project-desc">{{item.projectDescribe}}</p>
        </div>
        <!-- 右侧：预算+工期 -->
        <div class="item-right">
          <div class="info-item">
            <span class="info-label">预算</span>
            <span class="info-value">{{item.projectSpendStr}}</span>
          </div>
          <div class="info-item">
            <span class="info-label">工期</span>
            <span class="info-value">{{item.expectDay}}天</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页器 -->
    <el-pagination
      @current-change="handleCurrentChange"
      layout="prev, pager, next"
      class="pagination"
      :page-size="pageSize"
      :total="total"
      v-if="total>0"
    >
    </el-pagination>
  </div>
</template>

<script>
import { prjIntroGetAuditeProjectList } from "../utils/records";
export default {
  data() {
    return {
      dataList: [],
      total: 0,
      pageNo: 1,
      pageSize: 6,
    };
  },
  props: {
    type: {
      type: String,
    },
  },
  methods: {
    // 分页
    handleCurrentChange(page) {
      this.pageNo = page;
      this.getList();
    },
    handleDetail(item) {
      this.$router.push({ path: "/recordsDetail", query: { item: encodeURIComponent(JSON.stringify(item)) } });
    },
    getList() {
      let data = {
        currentPage: this.pageNo,
        pageSize: this.pageSize,
        type: this.type,
        status: 0,
      };
      prjIntroGetAuditeProjectList(data).then((res) => {
        // console.log('@',res);
        if (res.data.code == 200) {
          this.$nextTick(() => {
            this.dataList = res.data.data;
            this.total = res.data.total;
          });
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
  activated() {
    this.getList();
  },
};
</script>

<style scoped lang="less">
.fontdemo(@size,@family,@weight,@color) {
  font-size: @size;
  font-family: @family;
  font-weight: @weight;
  color: @color;
}

/* 整体容器 - 深色主题适配 */
.advertisement-content{
  width: 100%;
  min-height: calc(100vh - 300px);
  box-sizing: border-box;
  padding: 52px 120px 80px;
  background: #232732;
  font-family: PingFangSC, PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif;

  /* 列表容器 - 纵向排列 */
  &-list{
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 24px;

    /* 列表项卡片 - 1:1匹配设计图 */
    &-item{
      width: 100%;
      box-sizing: border-box;
      padding: 24px 32px;
      background: #121212;
      border: 1px solid #F9C92E;
      border-radius: 8px;
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: all 0.3s ease;

      /* hover交互效果 */
      &:hover{
        transform: translateY(-2px);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4);
        border-color: #ffd700;
      }

      /* 左侧用户信息区 */
      .item-left{
        display: flex;
        align-items: center;
        gap: 12px;
        flex-shrink: 0;

        .user-avatar{
          width: 48px;
          height: 48px;
          border-radius: 50%;
          border: 2px solid #F9C92E;
          object-fit: cover;
        }

        .user-name{
          .fontdemo(16px, 'PingFangSC,PingFang SC', 500, #ffffff);
        }

        .user-type{
          width: 20px;
          height: auto;
        }
      }

      /* 中间项目信息区 */
      .item-middle{
        flex: 1;
        margin: 0 40px;

        .project-name{
          .fontdemo(18px, 'PingFangSC,PingFang SC', 600, #ffffff);
          margin: 0 0 8px 0;
          line-height: 1.3;
          text-align: left;
        }

        .project-desc{
          .fontdemo(14px, 'PingFangSC,PingFang SC', 400, rgba(255,255,255,0.6));
          line-height: 1.5;
          margin: 0;
          /* 2行文本溢出省略 */
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          text-align: left;

        }
      }

      /* 右侧预算工期区 */
      .item-right{
        display: flex;
        align-items: center;
        gap: 60px;
        flex-shrink: 0;

        .info-item{
          text-align: right;

          .info-label{
            display: block;
            .fontdemo(12px, 'PingFangSC,PingFang SC', 400, rgba(255,255,255,0.5));
            margin-bottom: 4px;
          }

          .info-value{
            display: block;
            .fontdemo(18px, 'PingFangSC,PingFang SC', 600, #F9C92E);
            line-height: 1.2;
          }
        }
      }
    }
  }
}

/* 分页器样式 - 匹配设计图深色主题 */
.pagination{
  max-width: 1400px;
  margin: 32px auto 0;
  text-align: right;
}
/deep/ .el-pagination {
  color: rgba(255, 255, 255, 0.78);
}

/deep/ .btn-prev,
/deep/ .btn-next,
/deep/ .el-pager li {
  min-width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.8);
  margin: 0 8px;
}

/deep/ .el-pager .active {
  background: linear-gradient(135deg, #f9c92e 0%, #d8a516 100%);
  color: #141414;
}
</style>
